(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'a.header-logo[data-logo-scroll-reveal]';
    let frame = 0;

    function update() {
      frame = 0;
      document.querySelectorAll(selector).forEach(logo => {
        const wrapper = logo.closest('.page-wrapper');
        const scrollTop = Math.max(
          window.scrollY || 0,
          document.scrollingElement?.scrollTop || 0,
          wrapper?.scrollTop || 0
        );
        const threshold = Math.max(0, Number(logo.dataset.logoScrollThreshold) || 0);
        if (scrollTop <= 1) {
          logo.dataset.logoVisible = 'false';
        } else if (scrollTop >= threshold) {
          logo.dataset.logoVisible = 'true';
        }
      });
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
